import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./components/Header/Header";
import Deprecated from "./pages/Deprecated/Deprecated";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <BrowserRouter>
      <Header userData={{}} setUserData={() => {}} />
      <Routes>
        <Route path="*" element={<Deprecated />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
